import {authHeaders, baseUrl, handleError, handleResponse} from "./apiUtils";

function getBook(id) {
  return fetch(`${baseUrl}books/${id}`, {
    headers: authHeaders(),
  })
    .then(handleResponse)
    .catch(handleError);
}

function getBooks() {
  return fetch(`${baseUrl}books`, {
    headers: authHeaders(),
  })
    .then(handleResponse)
    .catch(handleError);
}

function saveBook(book) {
  return fetch(`${baseUrl}books/${book.id || ""}`, {
    method: book.id ? "PUT" : "POST", // POST for create, PUT to update when id already exists.
    headers: authHeaders({ "content-type": "application/json" }),
    body: JSON.stringify(book),
  })
    .then(handleResponse)
    .catch(handleError);
}


export default {
  getBook,
  getBooks,
  saveBook,
};
